import ExtendableError from 'es6-error';

class NetworkError extends ExtendableError {
  constructor(status = 500, json = {}, meta = {}) {
    super(json.message || 'Unexpected error');
    this.status = status;
    this.response = json;
    this.meta = meta;
  }
}

export default NetworkError;



// WEBPACK FOOTER //
// ./utils/error/NetworkError.js